import React, { useMemo, useCallback, useEffect, useRef, useState } from "react";
import { Animated, FlatList, View, TextInput, Dimensions, Platform, Alert, useWindowDimensions, TouchableOpacity, ImageBackground, Image } from "react-native";
import { Text, Title } from "@constants/Themed";
import { Checkbox, H3 } from "tamagui";
import { Card } from "@constants/Themed";
import { Pressable } from 'react-native-web';
import { useDispatch, useSelector } from 'react-redux';
import styles from "@stylesheet";
import * as WebBrowser from 'expo-web-browser';
import useForm from '@hooks/useForm';
import loginUser from '@api/login';
import { BACK_TO_LOGIN, CURRENT_PAGE, DISMISSED_APP_INFO, FAILED, HIDE_ALL_MODALS, HIDE_LOADING_MODAL, HIDE_PASSWORD_RESET_MODAL, HIDE_REGISTER_MODAL, HOLD_REGISTER_STATE_VALUES, INITIALISE_MENU, LOGIN_FLIP, RESET_APP, SHOW_AUTH_MODAL, SHOW_LOADING_MODAL, SHOW_OTP, SHOW_PASSWORD_RESET_MODAL, SHOW_REGISTER_MODAL, SHOW_TC_MODAL, SUCCESS, SWITCH_COMPANY_REQUEST, TOGGLE_OTP, SET_LEARNING_MODE, CLEAR_LEARNING_MODE, CHANGE_MENU, STORE_BUSINESS_PROMPT } from '@reduxLocal/actions/types';
import { DefaultRootState, store } from "@reduxLocal/persistState";
import LottieView from '@utils/lottieAnimation';
import { Entypo, Ionicons, EvilIcons, FontAwesome6, FontAwesome, AntDesign } from "@expo/vector-icons";
import apis, { registerUser, companyCheck, passwordReset } from '@api/api';
import DynamicContent from "../../../../components/login/DynamicLoginContent";
import DropSelect from "../../../../components/Global/DropSelect";
import { PanGestureHandler, ScrollView } from "react-native-gesture-handler";
import { useLottieAnim } from "@hooks/lottieHook";
import registrationInfo from "../Components/RegistrationInfo";
import { useTranslation } from "react-i18next";
import OTPInput from "../Components/OTPInput";
import { LinearGradient } from "expo-linear-gradient";
import CityScape from "@assets/--native/CityScape";
import PasswordResetModal from "../Components/PasswordResetModal";
import RegisterModal from "../../../../components/modals/RegisterModal/RegisterModal";
import TCModal from "../../../../components/modals/TCModal/TCModal";
import { Button, XStack, YStack } from 'tamagui';
import ChangeLogFetcher from '../../../logFetch';
import { H1, H2, H5, H4, Input, SizableText } from "tamagui";

// Utility function to normalize border styles and prevent conflicts
const normalizeBorderStyles = (styles: any) => {
  if (!styles) return styles;

  const normalized = { ...styles };

  // If both borderColor and specific border colors are present, use specific ones
  if (normalized.borderColor && (normalized.borderTopColor || normalized.borderRightColor || normalized.borderBottomColor || normalized.borderLeftColor)) {
    // Remove the shorthand borderColor to avoid conflicts
    delete normalized.borderColor;
  }

  return normalized;
};
import { useNetInfo } from "@react-native-community/netinfo";
import { m, motion } from 'framer-motion';
import { useRoute } from "@react-navigation/native";
import { CardBackground } from 'tamagui';
import LinkedInButton from "../Components/Authorisation/LinkedInButton";
import DiscordButton from "../Components/Authorisation/DiscordButton";
import LoadingModal from '../../../../components/modals/LoadingModal/LoadingModal';
import AuthModal from '../../../../components/modals/ErrorModal/AuthModal';
import OTPModal, { OTPModalRef } from '../../../../components/modals/OTPModal/OTPModal';
import Registration from "../Registration";
import {verifyOTPCode} from '@api/api';
import { fetchAndValidateSession } from './utils/authSessionHandler';
import BackendStatusIndicator from './Components/BackendStatusIndicator';



/*TODO implement complete Google and Facebook authentication requests and tokens, remaining documentation can be found here https://github.com/expo/expo/pull/9361
import * as Google from 'expo-auth-session/providers/Google';
import * as Facebook from 'expo-auth-session/providers/Facebook';
Login Screen begins
*/

const LoginScreen = ({ navigation }) => {
  const { t } = useTranslation();
  const [loginHovered, setLoginHovered] = useState(false);
  const [registerHovered, setRegisterHovered] = useState(false);
  const [renderingView, setRenderingView] = useState(false);
  const [passwordHidden, setPasswordHidden] = useState(true);
  const { products, modalDisplayed, selectedPlan } = useSelector((state: DefaultRootState) => state.modals.registerModal);
  const flip = useSelector((state: DefaultRootState) => state.navigation?.loginFlip);
  const userState = useSelector((state: DefaultRootState) => state.promiseData);
  const registerModalState = useSelector((state: DefaultRootState) => state.modals.registerModal.modalDisplayed);
  const selectedPlanState = useSelector((state: DefaultRootState) => state.modals.registerModal.selectedPlan);
  const passwordResetModalState = useSelector((state: DefaultRootState) => state.modals?.passwordModalDisplayed);
  const appVersion = useSelector((state: DefaultRootState) => state.app.appVersion)
  const theme = useSelector((state: DefaultRootState) => state.app.theme.lightTheme);
  const [open, setOpen] = useState(false);
  const [departmentOpen, setDepartmentOpen] = useState(false);
  const [accessState, setAccessState] = useState(null);
  const [departmentState, setDepartmentState] = useState(null);
  const [otpCode, setOTPCode] = useState("");
  const [passwordResetEmail, setPasswordResetEmail] = useState('');
  const [isPinReady, setIsPinReady] = useState(false);
  const maximumCodeLength = 6;
  const [awaitingPasscode, setAwaitingPasscode] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const showOtp = useSelector((state: DefaultRootState) => state.UI.showOTP);
  const loginForm = useRef(null);
  const [xyValue, setXYValue] = useState(0);
  const [inverseXYValue, setInverseXYValue] = useState(0);
  const [screenBreakPoint, setScreenBreakPoint] = useState(false);
  const dispatch = useDispatch();

  // On web, use CSS-based responsive design (viewport units, percentages) instead of JavaScript resize listeners
  // This prevents re-renders when keyboard appears. For native, use Dimensions API.
  // CRITICAL: We must call useWindowDimensions() hook (Rules of Hooks), but we'll ignore its updates for keyboard resizes on web
  const windowDimensionsHook = useWindowDimensions();
  const windowDimensions = Platform.OS === 'web'
    ? { width: typeof window !== 'undefined' ? window.innerWidth : 1024, height: typeof window !== 'undefined' ? window.innerHeight : 768 }
    : windowDimensionsHook;

  // Use CSS-based breakpoints on web (no JavaScript calculations needed)
  // Breakpoints are determined by CSS media queries via className/style, not JavaScript
  const breakpoints = useMemo(() => {
    // On web, we'll use CSS classes and viewport units, so we only need initial values
    // These are used for initial render only - CSS handles the rest
    if (Platform.OS === 'web') {
      // Use a simple initial check, but CSS will handle actual responsive behavior
      const initialWidth = typeof window !== 'undefined' ? window.innerWidth : 1024;
      return {
        isMobile: initialWidth < 768,
        isTablet: initialWidth >= 768 && initialWidth < 1024,
        isDesktop: initialWidth >= 1024,
        isLargeDesktop: initialWidth >= 1440,
        // Height classifications - use viewport units in CSS instead
        isShortScreen: false, // CSS handles this
        isMediumScreen: false, // CSS handles this
        isTallScreen: false, // CSS handles this
        isMobilePortrait: false, // CSS handles this
        isMobileLandscape: false, // CSS handles this
        isCompactHeight: false, // CSS handles this
      };
    }

    // For native, calculate from actual dimensions (but this memo never recalculates due to empty deps)
    const { width, height } = windowDimensionsHook;
    return {
      isMobile: width < 768,
      isTablet: width >= 768 && width < 1024,
      isDesktop: width >= 1024,
      isLargeDesktop: width >= 1440,
      isShortScreen: height < 600,
      isMediumScreen: height >= 600 && height < 900,
      isTallScreen: height >= 900,
      isMobilePortrait: width < 768 && height > width,
      isMobileLandscape: width < 768 && width > height,
      isCompactHeight: height < 700,
    };
  }, []); // Empty deps - CSS handles responsive behavior on web, no need to recalculate

    // Modern responsive scaling system
    const getResponsiveStyles = () => {
      const { isMobile, isTablet, isDesktop, isShortScreen, isMediumScreen } = breakpoints;

      // Base scale factors for different screen sizes
      const getScaleFactor = () => {
        if (isMobile && isShortScreen) return 0.75;
        if (isMobile) return 0.85;
        if (isTablet) return 0.95;
        return 1;
      };

      const scaleFactor = getScaleFactor();

      return {
        // Spacing system
        spacing: {
          xs: Math.max(4, 8 * scaleFactor),
          sm: Math.max(8, 12 * scaleFactor),
          md: Math.max(12, 16 * scaleFactor),
          lg: Math.max(16, 24 * scaleFactor),
          xl: Math.max(24, 32 * scaleFactor),
          xxl: Math.max(32, 48 * scaleFactor),
        },

        // Container dimensions
        container: {
          maxWidth: isMobile ? 400 : isTablet ? '85%' : '70%',
          minWidth: Math.max(320, isMobile ? 300 : 500),
          padding: {
            horizontal: isMobile ? '4%' : isTablet ? '6%' : '8%',
            vertical: isShortScreen ? '2%' : isMediumScreen ? '3%' : '4%'
          }
        },

        // Typography scale
        typography: {
          xs: Math.max(10, 12 * scaleFactor),
          sm: Math.max(12, 14 * scaleFactor),
          base: Math.max(14, 16 * scaleFactor),
          lg: Math.max(16, 18 * scaleFactor),
          xl: Math.max(18, 20 * scaleFactor),
          xxl: Math.max(20, 24 * scaleFactor),
        },

        // Component sizing
        components: {
          cardRadius: isMobile ? 12 : 16,
          buttonHeight: Math.max(44, 48 * scaleFactor), // Minimum 44px for touch targets
          inputHeight: Math.max(40, 44 * scaleFactor),
          iconSize: Math.max(20, 24 * scaleFactor),
        }
      };
    };

    const responsive = getResponsiveStyles();

    const route = useRoute();
  const { code, productId, learningMode: routeLearningMode } = route.params as { code?: { code: string }, productId?: string, learningMode?: boolean } | undefined || {};

  // Comment out changelog fetcher for web
  // ChangeLogFetcher();
  if (Platform.OS !== 'web') {
    ChangeLogFetcher();
  }

  // Detect learning mode from route or URL
  useEffect(() => {
    const isLearnRoute = route.name === 'Learn';
    const hasLearningParam = routeLearningMode === true;

    // Check URL params on web
    let hasUrlParam = false;
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      hasUrlParam = urlParams.get('learning') === 'true' ||
        urlParams.get('learn') === 'true' ||
        window.location.pathname.includes('/learn');
    }

    const shouldEnableLearningMode = isLearnRoute || hasLearningParam || hasUrlParam;

    if (shouldEnableLearningMode) {
      dispatch({ type: SET_LEARNING_MODE });
      // Automatically set menu to 'learning' - this is handled by navigationReducer
      dispatch({ type: CHANGE_MENU, payload: 'learning' });
      console.log('🎓 Learning mode enabled - paid features will be restricted and menu locked to "learning"');
    } else {
      dispatch({ type: CLEAR_LEARNING_MODE });
    }
  }, [route.name, routeLearningMode, dispatch]);

  // Detect and store business prompt from URL query parameter
  useEffect(() => {
    if (Platform.OS === 'web' && typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const prompt = urlParams.get('prompt');

      if (prompt) {
        // Decode the prompt and store it in Redux
        const decodedPrompt = decodeURIComponent(prompt);
        console.log('📝 [LoginScreen] Detected business prompt from URL:', decodedPrompt);
        dispatch({ type: STORE_BUSINESS_PROMPT, payload: decodedPrompt });
      }
    }
  }, [dispatch]);

    const translateX = new Animated.Value(xyValue);
    const inverseTranslateX = new Animated.Value(inverseXYValue);

    //TODO Create custom scrollbar into hook
    const [completeScrollBarHeight, setCompleteScrollBarHeight] = useState(1);
    const [visibleScrollBarHeight, setVisibleScrollBarHeight] = useState(0);
    const scrollIndicatorSize =
      completeScrollBarHeight > visibleScrollBarHeight
        ? (visibleScrollBarHeight * visibleScrollBarHeight) /
        completeScrollBarHeight
        : visibleScrollBarHeight;

    const scrollIndicator = useRef(new Animated.Value(0)).current;
    const difference =
      visibleScrollBarHeight > scrollIndicatorSize
        ? visibleScrollBarHeight - scrollIndicatorSize
        : 1;

    const scrollIndicatorPosition = Animated.multiply(
      scrollIndicator,
      visibleScrollBarHeight / completeScrollBarHeight
    ).interpolate({
      inputRange: [0, difference],
      outputRange: [0, difference],
      extrapolate: 'clamp'
    });
    //Switch Variables
    const [isUserOrganisation, setIsUserOrganisation] = useState(false);
    const [loaded, setLoaded] = useState(true);
    const toggleSwitch = () => setIsUserOrganisation(!isUserOrganisation);
    //TODO #43 Create dynamic state for access state that will be picked up from the component
    const [items, setItems] = useState([{ label: 'SuperAdmin', value: 'SuperAdmin' }, { label: 'Admin', value: 'Admin' }]);
    const [departmentItems, setDepartmentItems] = useState([{ label: 'Management', value: 'Management' }, { label: 'Sales', value: 'Sales' }, { label: 'Finance', value: 'Finance' }, { label: 'Administration', value: 'Administration' }]);
    const animation = useLottieAnim();
  const [showTypeSelection, setShowTypeSelection] = useState(true);
    const loggedOut = useSelector((state: DefaultRootState) => state.app.loggedOut);
  const learningMode = useSelector((state: DefaultRootState) => state.app.learningMode);
    const fadeAnim = useRef(new Animated.Value(0)).current;
  const registerForm = useRef(null);
  const [isChecked, setChecked] = useState(false);
  const [submitHovered, setSubmitHovered] = useState(false);
  const currentPage = useSelector((state: DefaultRootState) => state.navigation?.page.name);
  const appInfo = useSelector((state: DefaultRootState) => state.UI.appInfo);
  const [switchLogin, setSwitchLogin] = useState(true);
  const [showSwipeHelp, setShowSwipeHelp] = useState(true);
  const isConnected = useNetInfo().isConnected;
  const [codeVerified, setCodeVerified] = useState<any>(null);

    const [showCookiePolicy, setShowCookiePolicy] = useState(false);
  const [notifyUser, setNotifyUser] = useState(false); // Only set to true when productId is present
  const [validatedProduct, setValidatedProduct] = useState(null); // Store validated product details
  const [showMinimizedNotification, setShowMinimizedNotification] = useState(false); // Show circle indicator
    // Animation visibility state
    const [animationVisible, setAnimationVisible] = useState(true);
    const [animationKey, setAnimationKey] = useState(0); // Key to force re-render
  // Track if animation finish has been logged to prevent duplicate logs on re-renders
  const animationFinishLoggedRef = useRef<boolean>(false);

    // New user signup flow states
    const [showPlanSelection, setShowPlanSelection] = useState(false);
    const [newUserData, setNewUserData] = useState(null);
    const [isAnimatingContent, setIsAnimatingContent] = useState(false);

    // Plan data states
    const [plans, setPlans] = useState([]);
    const [plansLoading, setPlansLoading] = useState(false);
    const [plansError, setPlansError] = useState(null);

    // Animation refs for plan selection
  const planSelectionAnim = useRef(new Animated.Value(0)).current;
    
    // OTP Modal ref
    const otpModalRef = useRef<OTPModalRef>(null);

    // Check cookie policy acceptance on mount
    useEffect(() => {
      if (Platform.OS === 'web') {
        const cookieAccepted = localStorage.getItem('smartsaas-cookie-policy-accepted');
        if (!cookieAccepted) {
          // Show cookie policy after a short delay for better UX
          const timer = setTimeout(() => {
            setShowCookiePolicy(true);
          }, 2000);
          return () => clearTimeout(timer);
        }
      }
    }, []);

    const handleCookieAccept = () => {
      if (Platform.OS === 'web') {
        localStorage.setItem('smartsaas-cookie-policy-accepted', 'true');
        localStorage.setItem('smartsaas-cookie-policy-timestamp', new Date().toISOString());
      }
      setShowCookiePolicy(false);
    };

    const handleCookieDecline = () => {
      if (Platform.OS === 'web') {
        localStorage.setItem('smartsaas-cookie-policy-accepted', 'false');
        localStorage.setItem('smartsaas-cookie-policy-timestamp', new Date().toISOString());
        // Optionally disable analytics/tracking here
      }
      setShowCookiePolicy(false);
    };

    useEffect(() => {
      const verifyCode = async () => {
        try {
          const res = await apis.verifyCouponCode(code?.code);
          setCodeVerified(res.data);
        } catch (error) {
          console.error("Code verification failed:", error);
          setCodeVerified(null);
        }
      }

      if (code?.code) {
        verifyCode();
      }
    }, [code])

  // Set notifyUser to true only once when productId is present and validated
  useEffect(() => {
    const validateAndNotifyProduct = async () => {
      if (productId) {
        try {
          const response = await apis.getProductById(productId);

          // Check if the API response indicates the product exists
          if (response && (response.success || response.data)) {
            const productData = response.data || response;
            const productName = productData.name || productData.product_name || productData.title || productId;

            setValidatedProduct({
              id: productId,
              name: productName,
              ...productData
            });
            setNotifyUser(true);
          } else {
            console.warn("⚠️ Product validation failed - product not found:", productId);
            setValidatedProduct(null);
            setNotifyUser(false);
          }
        } catch (error) {
          console.error("❌ Error validating product:", error);
          console.warn("Product ID", productId, "could not be validated");
          setValidatedProduct(null);
          setNotifyUser(false);
        }
      } else {
        setValidatedProduct(null);
        setNotifyUser(false);
      }
    };

    validateAndNotifyProduct();
  }, [productId]); // Only run when productId changes (including initial load)

    // Fetch plans from backend
    useEffect(() => {
      const fetchPlans = async () => {
        setPlansLoading(true);
        setPlansError(null);

        try {
          console.log('🔄 Fetching comprehensive pricing plans from backend...');
          const response = await apis.getPlanSubscriptions();

          if (response.success && response.data) {
            // The new API returns comprehensive plans with both product and subscription options
            console.log('📦 Received comprehensive plans from Stripe:', response.data.length);

            const comprehensivePlans = response.data;

            // Transform the comprehensive plans to match the existing UI format
            const transformedPlans = comprehensivePlans.map((plan, index) => {
              return {
                id: plan.id,
                name: plan.name,
                price: plan.price,
                period: plan.period,
                features: plan.features,
                popular: plan.popular,
                color: plan.color,
                description: plan.description,
                priceId: plan.primary_price_id,
                productId: plan.stripe_product_id,
                isActive: plan.active,

                // Add comprehensive pricing options for future use
                pricingOptions: plan.pricing,
                hasMonthly: plan.has_monthly,
                hasYearly: plan.has_yearly,
                hasOneTime: plan.has_one_time,
                tier: plan.tier
              };
            });

            setPlans(transformedPlans);
            console.log('📋 Plan details:', transformedPlans.map(p => ({
              name: p.name,
              price: p.price,
              tier: p.tier,
              hasMonthly: p.hasMonthly,
              hasYearly: p.hasYearly,
              hasOneTime: p.hasOneTime
            })));
          } else {
            throw new Error('Invalid response format from server');
          }
        } catch (error) {
          console.error('❌ Error fetching plans:', error);
          setPlansError(error.message || 'Failed to load plans');

          // Fallback to default plans
          const fallbackPlans = [
            {
              id: 'fallback-free',
              name: 'Free Plan',
              price: 'Free',
              period: '',
              features: [
                '✅ Basic features',
                '✅ Email support',
                '✅ Community access'
              ],
              popular: false,
              color: '#10B981'
            }
          ];
          setPlans(fallbackPlans);
        } finally {
          setPlansLoading(false);
        }
      };

      fetchPlans();
    }, []);

    // Effect to handle animation visibility and reset
    useEffect(() => {
      // Reset animation if it becomes invisible
      if (!animationVisible) {
        const timer = setTimeout(() => {
          setAnimationKey(prev => prev + 1);
          setAnimationVisible(true);
        }, 100);
        return () => clearTimeout(timer);
      }
    }, [animationVisible]);

    // Monitor for animation issues
    useEffect(() => {
      const checkAnimation = () => {
        if (animation.current) {
          try {
            // Check if animation is still playable
            animation.current.play();
          } catch (error) {
            console.warn('Animation playback issue, resetting:', error);
            setAnimationKey(prev => prev + 1);
          }
        }
      };

      // Check animation periodically to prevent vanishing
      const interval = setInterval(checkAnimation, 5000);
      return () => clearInterval(interval);
    }, [animation]);

    const breakPoint = () => {
      if (Dimensions.get('window').width > 1200) {
        setScreenBreakPoint(true)
      } else {
        setScreenBreakPoint(false)
      }
    }

  // REMOVED: console.log("Login screen rendered") - was causing confusion
  // The component may re-render when useWindowDimensions() updates, but with our ref-based
  // stable dimensions, the visual output doesn't change, so it's not a problem

    //TODO remove looping state store !
    /* Redirecting user once data is fetched and data is not null and isAuthenticated = true */
    /* Redirect on Session retrieval */
    useEffect(() => {
      if (!loggedOut && userState?.data?.userData?.id) {
        // Check if we're already on Dashboard to avoid unnecessary navigation
        try {
          const navState = navigation.getState?.();
          const currentRoute = navState?.routes?.[navState?.index]?.name;
          if (currentRoute === 'Dashboard') {
            return;
          }
        } catch (e) {
          // Navigation state might not be available, continue
        }

        fetchAndValidateSession({
          dispatch,
          navigation,
          loggedOut,
          userId: userState.data.userData.id,
        }).then((result) => {
          setRenderingView(false);
          setXYValue(1);
        });
      }
    }, [userState, loggedOut]);

    /* use custom hook to handle form values and handle form submission value */
    const formLoginContext = useForm({
      initialValues: {
        email: null,
        password: null,
      },
      onSubmit: async (formValues) => {
        setTimeout(() => { setShowForgotPassword(true); }, 1000);
        // Learning mode will be automatically included from Redux state
        dispatch(loginUser(formValues, (data: { id: undefined; success: boolean }) => {
          if (data?.id !== undefined) {
            console.log('no data stored in id')
          }
        }));
      },
    })

    const handleLoginKeyDown = async (e: { nativeEvent: { key: string; }; }, formValues: any, data) => {
      if (e.nativeEvent.key == "Enter") {
        formLoginContext.handleSubmit;
      }
    }

    const checkedStyle = () => {
      if (!isChecked) {
        return [styles.LoginButtonDisabled, { minWidth: 200, alignSelf: 'stretch' }]
      } else if (submitHovered) {
        return [styles.LoginButtonHovered, { minWidth: 200 }]
      } else { return [styles.LoginButton, { minWidth: 200, backgroundColor: 'grey' }] }
    }


    const handleRegisterKeyDown = async (e: { nativeEvent: { key: string; }; }, formValues: any) => {
      if (e.nativeEvent.key == "Enter") {
        await dispatch(registerUser(formValues));
      }
    }

    function handleResetPress() {
      dispatch({ type: SHOW_PASSWORD_RESET_MODAL })
    }

    function privacyPolicy() {
      WebBrowser.openBrowserAsync(
        'https://smartsaas.co.uk/privacy-policy/'
      )
    }

    function termsAndConditions() {
      WebBrowser.openBrowserAsync(
        'https://smartsaas.co.uk/terms-and-conditions/'
      )
    }

    function handleAndroidPlayStore() {
      WebBrowser.openBrowserAsync(
        'https://play.google.com/store/apps/details?id=com.anonymous.smartsaas&gl=GB'
      )
    }

    function handleAppleAppStore() {
      Alert.alert('iOS coming soon!', 'Not to worry you can request earlier access by dropping us a message')
    }

    const DropDowns = () => {
      if (isUserOrganisation) {
        return (
          <View style={{ flex: 1 }}>
            <View style={{ minHeight: open ? 150 : 90, alignSelf: 'stretch' }}>
              <DropSelect zIndex={3000}
                zIndexInverse={1000} value={accessState} name={'access'} setValue={setAccessState} open={open}
                items={items} setOpen={setOpen} setItems={setItems} placeholder={`${t('accessLevel')}`} formContext={undefined} />
            </View>
            <View style={{ minHeight: departmentOpen ? 300 : 90, alignSelf: 'stretch' }}>
              <DropSelect zIndex={2000}
                zIndexInverse={2000} formContext={undefined} value={departmentState} name={'department'} setValue={setDepartmentState} open={departmentOpen}
                items={departmentItems} setOpen={setDepartmentOpen} setItems={setDepartmentItems} placeholder={'Department'} />
            </View>
          </View>
        )
      } else {
        return null
      }
    }

    const inverseCheckedStyle = () => {
      if (!isChecked) {
        return [styles.BackToLogin, { flex: 1, minWidth: 200 }]
      } else if (submitHovered) {
        return [styles.LoginButton, { minWidth: 200 }]
      } else { return [styles.LoginButtonHovered, { minWidth: 200 }] }
    }

    const handleLoginSwitch = useCallback((value) => {
      if (switchLogin) {
        Animated.timing(translateX, {
          toValue: 1,
          duration: 600,
          useNativeDriver: false
        }).start();
      } else {
        Animated.timing(inverseTranslateX, {
          toValue: 1,
          duration: 600,
          useNativeDriver: false
        }).start(({ finished }) => {
          setSwitchLogin(value)
        });
      }
      setSwitchLogin(value);
    }, [loaded])

    const gesture = (e) => {
      const { nativeEvent } = e;
      if (nativeEvent.translationX < -1) {
        setInverseXYValue(Math.abs(nativeEvent.translationX / 12));
      }
      if (nativeEvent.translationX > 1) {
        setXYValue(nativeEvent.translationX / 12);
      }
      if (nativeEvent.translationX < -150) {
        setXYValue(1);
        handleLoginSwitch(true);
      }
      else if (nativeEvent.translationX > 150) {
        setInverseXYValue(1);
        handleLoginSwitch(false);
      }
    };

    const ShowValidationOtp = () => {
      return (
        <View style={{ flex: 1 }}>
          <View style={{ flex: 1, alignSelf: 'center', top: 50 }}>
            <LottieView style={{ height: '100%' }} duration={5000} source={require('@assets/animations/105919-password-security.json')} autoPlay loop={false}></LottieView>
            <Text adjustsFontSizeToFit style={{ fontSize: 14, fontWeight: '400', textAlign: 'center' }}>Enter your One Time Password</Text>
          </View>
          <>
            <OTPInput />
          </>
        </View >
      )
    }

    async function handleUserData(res) {
      let amendedData = res.data.data;

      if (Platform.OS !== 'web') {
        let activeTokens = amendedData.notification_info?.map(item => item.notification_token) || [];

          // TODO: Get notification token from appropriate service
          const notificationToken = ''; // Placeholder - should get actual token
          if (!activeTokens.length || activeTokens.includes(notificationToken)) {
            await apis.updateNotificationToken(notificationToken, amendedData.userData.id);
          }

        amendedData.expireAt = Date.now() + 1000 * 60 * 60 * 24 * 7;
      }
      return amendedData;
    }

    // Handle new user signup callback
    const handleNewUserSignup = useCallback((userData) => {
      console.log('🎉 New user signed up:', userData);
      console.log('📧 Showing OTP verification for:', userData?.email);
      
      // Show OTP modal as the first stage
      otpModalRef.current?.show(userData);
    }, []);

    // Handle OTP verification completion
    const handleOtpVerificationComplete = useCallback(async (userData, otpCode) => {
      return new Promise(async (resolve, reject) => {
        try {
          // Verify OTP code
          const res = await verifyOTPCode(userData.email, otpCode);
          
          if (res.success) {
            console.log('👤 Proceeding with user data:', userData);
            
            setNewUserData(userData);
            setIsAnimatingContent(true);

            // Animate plan selection in
            Animated.timing(planSelectionAnim, {
              toValue: 1,
              duration: 600,
              useNativeDriver: false,
            }).start(() => {
              setShowPlanSelection(true);
              setIsAnimatingContent(false);
              resolve({ success: true });
            });
          } else {
            resolve({ success: false });
          }
        } catch (error) {
          console.error('❌ Error during OTP verification:', error);
          reject({ success: false, error });
        }
      });
    }, [planSelectionAnim]);

    // Handle OTP modal cancel
  const handleOtpCancel = useCallback(() => {
      // Reset any signup state if needed
    setNewUserData(null);
    setShowPlanSelection(false);
    setIsAnimatingContent(false);
    }, []);

    // Handle plan selection completion
    const handlePlanSelectionComplete = useCallback((selectedPlan) => {
      console.log('📋 Plan selected:', selectedPlan);

      // Store the plan selection for the user
      if (selectedPlan) {

        // You might want to send the plan selection to your backend here
        // await api.updateUserPlanSelection(newUserData.email, selectedPlan.id);

        // Navigate to dashboard with plan information
        navigation.replace('Dashboard', {
          screen: 'Welcome',
          params: {
            newUser: true,
            userData: newUserData,
            selectedPlan: selectedPlan,
            message: `Welcome! You've selected the ${selectedPlan.name} plan. Payment instructions have been sent to your email.`
          }
        });
      } else {
        // Continue with free plan
        navigation.replace('Dashboard', {
          screen: 'Welcome',
          params: {
            newUser: true,
            userData: newUserData,
            message: 'Welcome! You can upgrade to a paid plan anytime from your account settings.'
          }
        });
      }
    }, [navigation, newUserData]);

    // Handle plan selection cancel/back
    const handlePlanSelectionCancel = useCallback(() => {
      // Animate back to original state
      Animated.timing(planSelectionAnim, {
        toValue: 0,
        duration: 600,
        useNativeDriver: false,
      }).start(() => {
        setShowPlanSelection(false);
        setNewUserData(null);
      });
    }, [planSelectionAnim]);

    // Plan Selection Component
    const PlanSelectionPanel = () => {
      return (
        <Animated.View style={{
          position: 'absolute',
          top: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          backgroundColor: theme ? 'rgba(255, 255, 255, 0.98)' : 'rgba(30, 30, 30, 0.98)',
          transform: [{
            translateX: planSelectionAnim.interpolate({
              inputRange: [0, 1],
              outputRange: [Platform.OS === 'web' ? (typeof window !== 'undefined' ? window.innerWidth : 1024) : windowDimensionsHook.width, 0],
            })
          }],
          zIndex: 1000,
          ...Platform.select({
            web: {
              backdropFilter: 'blur(20px)',
            }
          }),
        }}>
          <View style={{
            flex: 1,
            padding: responsive.spacing.xl,
            paddingTop: responsive.spacing.xxl,
          }}>
            {/* Header */}
            <View style={{
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              marginBottom: responsive.spacing.xl,
            }}>
              <TouchableOpacity
                onPress={handlePlanSelectionCancel}
                style={{
                  padding: responsive.spacing.sm,
                  borderRadius: 8,
                  backgroundColor: theme ? '#F3F4F6' : '#374151',
                }}
              >
                <FontAwesome6
                  name="arrow-left"
                  size={responsive.components.iconSize}
                  color={theme ? '#6B7280' : '#D1D5DB'}
                />
              </TouchableOpacity>
              <H2 style={{
                fontSize: responsive.typography.xxl,
                fontWeight: '700',
                color: theme ? '#1F2937' : '#F9FAFB',
                textAlign: 'center',
                flex: 1,
              }}>
                An Exclusive Offer Just for You!
              </H2>
              <View style={{ width: responsive.components.iconSize + responsive.spacing.sm * 2 }} />
            </View>

            {/* Welcome Message */}
            <View style={{
              backgroundColor: theme ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.2)',
              padding: responsive.spacing.lg,
              borderRadius: 12,
              marginBottom: responsive.spacing.xl,
            }}>
              <Text style={{
                fontSize: responsive.typography.base,
                color: theme ? '#1F2937' : '#F9FAFB',
                textAlign: 'center',
                lineHeight: responsive.typography.base * 1.4,
              }}>
                🎉 Welcome to SmartSaaS, {newUserData?.fullName || 'there'}!
                {'\n'}Select a plan to get started. Payment instructions will be sent to your email if you choose a paid plan.
              </Text>
            </View>

            {/* Plans */}
            <ScrollView showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
              {plansLoading ? (
                <View style={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingVertical: responsive.spacing.xxl,
                }}>
                  <Text style={{
                    fontSize: responsive.typography.lg,
                    color: theme ? '#6B7280' : '#9CA3AF',
                    marginBottom: responsive.spacing.md,
                    textAlign: 'center',
                  }}>
                    Loading pricing plans...
                  </Text>
                  <View style={{
                    width: 40,
                    height: 40,
                    borderRadius: 20,
                    borderWidth: 3,
                    borderColor: theme ? '#E5E7EB' : '#374151',
                    borderTopColor: '#3B82F6',
                    // Note: CSS animation doesn't work in React Native, you'd need to use Animated
                  }} />
                </View>
              ) : plansError ? (
                <View style={{
                  flex: 1,
                  justifyContent: 'center',
                  alignItems: 'center',
                  paddingVertical: responsive.spacing.xxl,
                }}>
                  <Text style={{
                    fontSize: responsive.typography.lg,
                    color: '#EF4444',
                    textAlign: 'center',
                    marginBottom: responsive.spacing.lg,
                    fontWeight: '600',
                  }}>
                    Failed to load pricing plans
                  </Text>
                  <Text style={{
                    fontSize: responsive.typography.base,
                    color: theme ? '#6B7280' : '#9CA3AF',
                    textAlign: 'center',
                    marginBottom: responsive.spacing.lg,
                  }}>
                    {plansError}
                  </Text>
                  <TouchableOpacity
                    onPress={() => {
                      setPlansError(null);
                      setPlansLoading(true);
                      // The useEffect will automatically re-run
                    }}
                    style={{
                      backgroundColor: '#3B82F6',
                      paddingHorizontal: responsive.spacing.lg,
                      paddingVertical: responsive.spacing.md,
                      borderRadius: responsive.components.cardRadius,
                    }}
                    >
                      <Text style={{
                        color: 'white',
                        fontSize: responsive.typography.base,
                        fontWeight: '600',
                      }}>
                        Try Again
                      </Text>
                    </TouchableOpacity>
                  </View>
                ) : (
                  <View style={{
                    paddingBottom: responsive.spacing.xl,
                  }}>
                    {/* One-Time Purchases Section */}
                    {plans.filter(plan => plan.hasOneTime && !plan.hasMonthly && !plan.hasYearly).length > 0 && (
                      <>
                        <View style={{
                          marginBottom: responsive.spacing.lg,
                          alignItems: 'center',
                        }}>
                          <LinearGradient
                            colors={theme ? ['#667eea', '#764ba2'] : ['#4a90e2', '#357abd']}
                            start={{ x: 0, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            style={{
                              paddingHorizontal: responsive.spacing.xl,
                              paddingVertical: responsive.spacing.md,
                              borderRadius: 25,
                              shadowColor: theme ? '#667eea' : '#4a90e2',
                              shadowOffset: { width: 0, height: 4 },
                              shadowOpacity: 0.3,
                              shadowRadius: 8,
                              elevation: 8,
                              }}
                            >
                              <Text style={{
                                fontSize: responsive.typography.lg,
                                fontWeight: '700',
                                color: 'white',
                                textAlign: 'center',
                                textShadowColor: 'rgba(0,0,0,0.3)',
                                textShadowOffset: { width: 1, height: 1 },
                                textShadowRadius: 2,
                              }}>
                                💎 One-Time Purchases (Paid annually)
                              </Text>
                            </LinearGradient>
                          </View>
                          <View style={{
                            flexDirection: breakpoints.isMobile ? 'column' : 'row',
                            gap: responsive.spacing.lg,
                            marginBottom: responsive.spacing.xl,
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                          }}>
                            {plans.filter(plan => plan.hasOneTime && !plan.hasMonthly && !plan.hasYearly).map((plan) => (
                              <View
                                key={plan.id}
                                style={{
                                  minWidth: breakpoints.isMobile ? '100%' : 280,
                                  maxWidth: breakpoints.isMobile ? '100%' : 350,
                                  marginBottom: breakpoints.isMobile ? responsive.spacing.md : 0,
                                }}
                              >
                                <LinearGradient
                                  colors={plan.popular
                                    ? ['#FF6B6B', '#4ECDC4', '#45B7D1']
                                    : ['#667eea', '#764ba2', '#f093fb']
                                  }
                                  start={{ x: 0, y: 0 }}
                                  end={{ x: 1, y: 1 }}
                                  style={{
                                    padding: 4,
                                    borderRadius: 20,
                                    shadowColor: plan.popular ? '#FF6B6B' : '#667eea',
                                    shadowOffset: { width: 0, height: 8 },
                                    shadowOpacity: 0.4,
                                    shadowRadius: 16,
                                    elevation: 12,
                                  }}
                                >
                                  <TouchableOpacity
                                    onPress={() => handlePlanSelectionComplete(plan)}
                                    style={{
                                  backgroundColor: theme ? '#FFFFFF' : '#1F2937',
                                  borderRadius: 16,
                                  padding: responsive.spacing.lg,
                                  position: 'relative',
                                  ...Platform.select({
                                    web: {
                                      boxShadow: plan.popular ?
                                        `0 8px 32px ${plan.color}40` :
                                        '0 4px 16px rgba(0, 0, 0, 0.1)',
                                    },
                                    default: {
                                      shadowColor: plan.color,
                                      shadowOffset: { width: 0, height: plan.popular ? 8 : 4 },
                                      shadowOpacity: plan.popular ? 0.3 : 0.1,
                                      shadowRadius: plan.popular ? 16 : 8,
                                      elevation: plan.popular ? 12 : 6,
                                    }
                                  }),
                                }}
                                  >
                                    {plan.popular && (
                                      <View style={{
                                        position: 'absolute',
                                        top: -12,
                                        left: responsive.spacing.lg,
                                        right: responsive.spacing.lg,
                                        backgroundColor: plan.color,
                                        borderRadius: 20,
                                        paddingVertical: 6,
                                        paddingHorizontal: 12,
                                        alignItems: 'center',
                                      }}>
                                        <Text style={{
                                          fontSize: responsive.typography.sm,
                                          fontWeight: '700',
                                          color: 'white',
                                        }}>
                                          MOST POPULAR
                                        </Text>
                                      </View>
                                    )}

                                    <View style={{ marginTop: plan.popular ? responsive.spacing.sm : 0 }}>
                                      <H3 style={{
                                        fontSize: responsive.typography.xl,
                                        fontWeight: '700',
                                        color: plan.color,
                                        marginBottom: responsive.spacing.xs,
                                  }}>
                                        {plan.name}
                                      </H3>

                                      <XStack alignItems="baseline" space="$1" marginBottom="$4">
                                        <Text style={{
                                          fontSize: responsive.typography.xxl * 1.2,
                                          fontWeight: '800',
                                          color: theme ? '#1F2937' : '#F9FAFB',
                                        }}>
                                          {plan.price}
                                        </Text>
                                        <Text style={{
                                          fontSize: responsive.typography.sm,
                                          color: theme ? '#6B7280' : '#9CA3AF',
                                        }}>
                                          {plan.period}
                                        </Text>
                                      </XStack>

                                      <YStack space="$2">
                                        {plan.features.map((feature, index) => (
                                          <Text key={index} style={{
                                            fontSize: responsive.typography.sm,
                                            color: theme ? '#374151' : '#D1D5DB',
                                            lineHeight: responsive.typography.sm * 1.4,
                                          }}>
                                            {typeof feature === 'string' ? feature : feature.name || 'Feature included'}
                                          </Text>
                                        ))}
                                      </YStack>
                                    </View>
                                  </TouchableOpacity>
                                </LinearGradient>
                              </View>
                            ))}
                          </View>
                        </>
                      )}

                      {/* Subscription Plans Section */}
                      {plans.filter(plan => plan.hasMonthly || plan.hasYearly).length > 0 && (
                        <>
                          <View style={{
                            marginBottom: responsive.spacing.lg,
                            alignItems: 'center',
                          }}>
                            <LinearGradient
                              colors={theme ? ['#f093fb', '#f5576c', '#4facfe'] : ['#667eea', '#764ba2', '#f093fb']}
                              start={{ x: 0, y: 0 }}
                              end={{ x: 1, y: 0 }}
                              style={{
                                paddingHorizontal: responsive.spacing.xl,
                                paddingVertical: responsive.spacing.md,
                                borderRadius: 25,
                                shadowColor: theme ? '#f093fb' : '#667eea',
                                shadowOffset: { width: 0, height: 4 },
                                shadowOpacity: 0.3,
                                shadowRadius: 8,
                                elevation: 8,
                              }}
                            >
                              <Text style={{
                                fontSize: responsive.typography.lg,
                                fontWeight: '700',
                                color: 'white',
                                textAlign: 'center',
                                textShadowColor: 'rgba(0,0,0,0.3)',
                                textShadowOffset: { width: 1, height: 1 },
                                textShadowRadius: 2,
                              }}>
                                🔄 Subscription Plans (Paid monthly)
                              </Text>
                            </LinearGradient>
                          </View>
                          <View style={{
                            flexDirection: breakpoints.isMobile ? 'column' : 'row',
                            gap: responsive.spacing.lg,
                            marginBottom: responsive.spacing.xl,
                            flexWrap: 'wrap',
                            justifyContent: 'center',
                          }}>
                            {plans.filter(plan => plan.hasMonthly || plan.hasYearly).map((plan) => (
                              <View
                                key={plan.id}
                                style={{
                                  minWidth: breakpoints.isMobile ? '100%' : 280,
                                  maxWidth: breakpoints.isMobile ? '100%' : 350,
                                  marginBottom: breakpoints.isMobile ? responsive.spacing.md : 0,
                                }}
                          >
                                <LinearGradient
                                  colors={plan.popular
                                    ? ['#4facfe', '#00f2fe', '#43e97b']
                                    : ['#f093fb', '#f5576c', '#4facfe']
                                  }
                                  start={{ x: 0, y: 0 }}
                                  end={{ x: 1, y: 1 }}
                                  style={{
                                    padding: 4,
                                    borderRadius: 20,
                                    shadowColor: plan.popular ? '#4facfe' : '#f093fb',
                                    shadowOffset: { width: 0, height: 8 },
                                    shadowOpacity: 0.4,
                                    shadowRadius: 16,
                                    elevation: 12,
                                  }}
                                >
                                  <TouchableOpacity
                                    onPress={() => handlePlanSelectionComplete(plan)}
                                    style={{
                                      backgroundColor: theme ? '#FFFFFF' : '#1F2937',
                                      borderRadius: 16,
                                      padding: responsive.spacing.lg,
                                      position: 'relative',
                                      ...Platform.select({
                                        web: {
                                          boxShadow: plan.popular ?
                                            `0 8px 32px ${plan.color}40` :
                                            '0 4px 16px rgba(0, 0, 0, 0.1)',
                                        },
                                        default: {
                                          shadowColor: plan.color,
                                          shadowOffset: { width: 0, height: plan.popular ? 8 : 4 },
                                          shadowOpacity: plan.popular ? 0.3 : 0.1,
                                          shadowRadius: plan.popular ? 16 : 8,
                                          elevation: plan.popular ? 12 : 6,
                                    }
                                  }),
                                }}
                                  >
                                    {plan.popular && (
                                      <View style={{
                                        position: 'absolute',
                                        top: -12,
                                        left: responsive.spacing.lg,
                                        right: responsive.spacing.lg,
                                        backgroundColor: plan.color,
                                        borderRadius: 20,
                                        paddingVertical: 6,
                                        paddingHorizontal: 12,
                                        alignItems: 'center',
                                      }}>
                                        <Text style={{
                                          fontSize: responsive.typography.sm,
                                          fontWeight: '700',
                                          color: 'white',
                                        }}>
                                          MOST POPULAR
                                        </Text>
                                      </View>
                                    )}

                                    <View style={{ marginTop: plan.popular ? responsive.spacing.sm : 0 }}>
                                      <H3 style={{
                                        fontSize: responsive.typography.xl,
                                        fontWeight: '700',
                                        color: plan.color,
                                        marginBottom: responsive.spacing.xs,
                                      }}>
                                        {plan.name}
                                      </H3>

                                      <XStack alignItems="baseline" space="$1" marginBottom="$4">
                                        <Text style={{
                                          fontSize: responsive.typography.xxl * 1.2,
                                          fontWeight: '800',
                                          color: theme ? '#1F2937' : '#F9FAFB',
                                        }}>
                                          {plan.price}
                                        </Text>
                                        <Text style={{
                                          fontSize: responsive.typography.sm,
                                          color: theme ? '#6B7280' : '#9CA3AF',
                                        }}>
                                          {plan.period}
                                        </Text>
                                      </XStack>

                                      <YStack space="$2">
                                        {plan.features.map((feature, index) => (
                                          <Text key={index} style={{
                                            fontSize: responsive.typography.sm,
                                            color: theme ? '#374151' : '#D1D5DB',
                                            lineHeight: responsive.typography.sm * 1.4,
                                          }}>
                                            {typeof feature === 'string' ? feature : feature.name || 'Feature included'}
                                          </Text>
                                        ))}
                                      </YStack>
                                    </View>
                                  </TouchableOpacity>
                                </LinearGradient>
                              </View>
                            ))}
                          </View>
                        </>
                      )}

                      {/* Continue Free Option */}
                      <TouchableOpacity
                        onPress={() => handlePlanSelectionComplete(null)}
                        style={{
                          backgroundColor: theme ? '#F9FAFB' : '#374151',
                          borderRadius: 12,
                          padding: responsive.spacing.lg,
                          borderWidth: 1,
                          borderColor: theme ? '#E5E7EB' : '#4B5563',
                          marginTop: responsive.spacing.lg,
                          alignItems: 'center',
                        }}
                      >
                    <Text style={{
                      fontSize: responsive.typography.base,
                      fontWeight: '600',
                      color: theme ? '#6B7280' : '#D1D5DB',
                      textAlign: 'center',
                    }}>
                      Continue with Free Tier
                    </Text>
                    <Text style={{
                      fontSize: responsive.typography.sm,
                      color: theme ? '#9CA3AF' : '#9CA3AF',
                      textAlign: 'center',
                      marginTop: 4,
                    }}>
                      You can upgrade anytime
                    </Text>
                  </TouchableOpacity>
                </View>
              )}
            </ScrollView>
          </View>
        </Animated.View>
      );
    };



    return (
      <View style={{
        flex: 1,
        flexDirection: (breakpoints.isDesktop && Platform.OS !== 'web') ? 'row-reverse' : 'column',
        minHeight: Platform.OS === 'web' ? ('100vh' as any) : '100%', // Use CSS viewport unit on web
        backgroundColor: 'transparent',
        position: 'relative',
        ...(Platform.OS === 'web' ? {
          overflow: 'hidden',
          justifyContent: 'center',
          alignItems: 'center',
          minWidth: 320,
          width: '100%',
          height: '100vh' as any, // Use CSS viewport unit - prevents keyboard-triggered re-renders
        } : {
          overflow: 'hidden',
        }),
      } as any}>
        {/* Modern Gradient Background - Matching Landing Page */}
        <LinearGradient
          colors={['#C8A2C8', '#87CEEB']}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
          }}
        />

        {/* Hero Background Image - Matching Landing Page */}
        {Platform.OS === 'web' && (
          <Image
            source={require('@assets/backgrounds/hero-bg.png')}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: '100%',
              height: '100%',
              opacity: 0.4,
              zIndex: 1,
              resizeMode: 'contain',
            }}
          />
        )}

        {/* Additional gradient overlay */}
        {Platform.OS === 'web' && (
          <View style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: theme ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)',
            zIndex: 2,
          }} />
        )}

        {/* Cityscape Overlay - Matching Hero.tsx */}
        {Platform.OS === 'web' && (
          <Image
            source={require('@assets/backgrounds/cityscape-large.png')}
            style={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: 256,
              width: '105%',
              zIndex: 6,
              opacity: 0.9,
              resizeMode: 'contain',
              marginHorizontal: -30,
              ...Platform.select({
                web: {
                  backgroundPosition: 'bottom',
                  backgroundSize: 'contain',
                  backgroundRepeat: 'no-repeat',
                }
              }),
            }}
          />
        )}
        <RegisterModal />
        <TCModal />
        <AuthModal />
        <LoadingModal />
        <PasswordResetModal emailForward={formLoginContext.values.email} />
        <OTPModal 
          ref={otpModalRef}
          onVerificationComplete={handleOtpVerificationComplete}
          onCancel={handleOtpCancel}
          theme={theme}
        />
        {/* Main Container - Matching Hero.tsx structure */}
          <ScrollView
            contentContainerStyle={{
              flexGrow: 1,
              justifyContent: 'center',
              alignItems: 'center',
            minHeight: Platform.OS === 'web' ? ('100vh' as any) : Math.max(windowDimensionsHook.height, 600), // Use CSS viewport unit on web
              paddingTop: 80,
              paddingBottom: 40,
              paddingHorizontal: breakpoints.isMobile ? 16 : 24,
          } as any}
            style={{
              flex: 1,
              zIndex: 10,
              position: 'relative',
              width: '100%',
              maxWidth: '1280px',
              margin: '0 auto',
              height: '100vh' as any,
              ...Platform.select({
                web: {
                  overflowY: 'auto',
                  overflowX: 'hidden',
                }
              }),
            } as any}
            showsVerticalScrollIndicator={false}
            bounces={false}
          >
            {/* Glass Card Container - Matching Hero.tsx */}
            <View style={{
              backgroundColor: theme ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
              backdropFilter: 'blur(20px)',
              borderRadius: 24,
              padding: breakpoints.isDesktop ? 48 : breakpoints.isTablet ? 32 : 24,
              width: '100%',
              top: "-5%",
              justifyContent:"center",
              minHeight: "80%",
              minWidth: breakpoints.isDesktop ? 900 : breakpoints.isTablet ? 700 : 320,
              maxWidth: breakpoints.isDesktop ? 1200 : '100%',
              borderWidth: 1,
              borderColor: theme ? 'rgba(255, 255, 255, 0.2)' : 'rgba(255, 255, 255, 0.1)',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
              alignSelf: 'center',
            } as any}>
              {/* Flex Row Layout - Animation and Form Side by Side */}
            <XStack flexWrap="wrap" style={{
                alignItems: 'center',
                gap: breakpoints.isDesktop ? 48 : 24,
                width: '100%',
                minHeight: "80%"
              }}>
                {/* Lottie Animation Section - Left Side */}
                <View style={{
                  flex: breakpoints.isDesktop ? 1 : 0,
                  minWidth: breakpoints.isDesktop ? 300 : '100%',
                  maxWidth: breakpoints.isDesktop ? 600 : '100%',
                  justifyContent: 'center',
                  alignItems: 'center',
                minHeight: Platform.OS === 'web' ? ('10vh' as any) : undefined
              } as any}>
                  {animationVisible && (
                    <LottieView
                      key={`landing-animation-${animationKey}`}
                      ref={animation}
                      style={{
                        minWidth: '150%',
                        height: breakpoints.isDesktop ? 400 : 200,
                        maxWidth: 600,
                      }}
                      source={require('@assets/animations/landing_Animation_dark.json')}
                      autoPlay={true}
                      loop={false}
                      speed={1}
                      onAnimationFinish={() => {
                        // Only log once - use a ref to track if we've already logged
                        if (!animationFinishLoggedRef.current) {
                          console.log('Landing animation finished');
                          animationFinishLoggedRef.current = true;
                        }
                      }}
                      onAnimationFailure={(error) => {
                        console.warn('Animation failed:', error);
                        setAnimationVisible(false);
                      }}
                      resizeMode="contain"
                      hardwareAccelerationAndroid={true}
                    />
                  )}
                  {!animationVisible && (
                    <View style={{
                      width: '100%',
                      height: breakpoints.isDesktop ? 400 : 200,
                      backgroundColor: theme ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.2)',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: 16,
                    }}>
                      <Text style={{
                        color: theme ? '#4F46E5' : '#818CF8',
                        fontSize: 24,
                        fontWeight: '600',
                      }}>
                        🚀 SmartSaaS
                      </Text>
                    </View>
                  )}
                </View>

                {/* Vertical Separator Line - Desktop Only */}
                {breakpoints.isDesktop && (
                  <View style={{
                    width: 1,
                    minHeight: 400,
                    backgroundColor: theme ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                    flexShrink: 0,
                  }} />
                )}
                {!breakpoints.isDesktop && (
                  <View style={{
                    width: '100%',
                    height: 1,
                    backgroundColor: theme ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)',
                    marginVertical: 24,
                  }} />
                )}

                {/* Registration Form Section - Right Side */}
                <View style={{
                  flex: breakpoints.isDesktop ? 3 : 1,
                minWidth: breakpoints.isDesktop ? 400 : '100%',
                  width: '100%',
                }}>
                  {/* Learning Mode Indicator */}
                  {learningMode && (
                    <View style={{
                      backgroundColor: theme ? '#3B82F6' : '#2563EB',
                      borderRadius: 8,
                      padding: 12,
                      marginHorizontal: "10%",
                      marginBottom: 16,
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderWidth: 2,
                      borderColor: theme ? '#60A5FA' : '#3B82F6',
                    }}>
                      <FontAwesome6
                        name="graduation-cap"
                        size={20}
                        color="#ffffff"
                        style={{ marginRight: 8 }}
                      />
                      <Text style={{
                        color: '#ffffff',
                        fontSize: 14,
                        fontWeight: '600',
                        textAlign: 'center',
                      }}>
                        Learning Mode Active - Explore without paid features
                      </Text>
                    </View>
                  )}
                  {/* Code Detection Visual Indicator */}
                  {codeVerified && (
                    <View style={{
                      backgroundColor: theme ? '#10B981' : '#059669',
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 16,
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                      <FontAwesome6
                        name="check-circle"
                        size={20}
                        color="#ffffff"
                        style={{ marginRight: 8 }}
                      />
                      <Text style={{
                        color: '#ffffff',
                        fontSize: 14,
                        fontWeight: '600',
                        textAlign: 'center',
                      }}>
                        {`🎉 Coupon code "${typeof code === 'object' && code?.code ? code.code : code}" applied successfully!`}
                      </Text>
                    </View>
                  )}
                  <Registration
                    flipCard={() => dispatch({
                      type: LOGIN_FLIP
                    })}
                    onNewUserSignup={handleNewUserSignup}
                    code={typeof code === 'object' && code?.code ? code.code : (typeof code === 'string' ? code : undefined)}
                    productId={productId}
                  />
                </View>
            </XStack>
            </View>
        </ScrollView>

        {/* Desktop Side Panel - Matching Landing Page Design */}
        {/* Hide side panel on web since changelog/journal is commented out */}
        {
          breakpoints.isDesktop && Platform.OS !== 'web' && (
            <View style={{
              flex: 1,
              zIndex: 2,
              overflow: "hidden",
              minHeight: windowDimensionsHook.height,
              position: 'relative',
            }}>
              {/* Main Content Area with Gradient Background */}
              <View style={{
                flex: 1,
              }}>
                <LinearGradient
                  colors={['#C8A2C8', '#87CEEB']}
                  start={{ x: 0, y: 0 }}
                  end={{ x: 1, y: 1 }}
                  style={{ flex: 1 }}
                >
                  {/* Glass morphism content container */}
                  <View style={{
                    flex: 1,
                    ...Platform.select({
                      web: {
                        backgroundColor: 'rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(10px)',
                      }
                    }),
                    padding: 40,
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}>
                    {/* Comment out DynamicContent (changelog/journal) for web */}
                    {Platform.OS !== 'web' && (
                      <DynamicContent {...{ registerModalState, selectedPlanState }} />
                    )}
                    {Platform.OS === 'web' && (
                      <View style={{
                        flex: 1,
                        justifyContent: 'center',
                        alignItems: 'center',
                        width: '100%',
                      }}>
                        <Text style={{
                          fontSize: 24,
                          fontWeight: '600',
                          color: theme ? '#1F2937' : '#F9FAFB',
                          textAlign: 'center',
                          marginBottom: 16,
                        }}>
                          Welcome to SmartSaaS
                        </Text>
                        <Text style={{
                          fontSize: 16,
                          color: theme ? '#6B7280' : '#D1D5DB',
                          textAlign: 'center',
                          maxWidth: 500,
                          minWidth: 400,
                        }}>
                          Sign in or create an account to get started
                        </Text>
                      </View>
                    )}
                  </View>

                  {/* Cityscape Overlay - Matching Landing Page */}
                  <CityScape style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: 256,
                    alignSelf: "flex-end",
                    justifyContent: "flex-end",
                    zIndex: 6,
                    maxHeight: '40%',
                    resizeMode: 'contain',
                    opacity: 0.9,
                    ...Platform.select({
                      web: {
                        backgroundPosition: 'bottom',
                        backgroundSize: 'contain',
                        backgroundRepeat: 'no-repeat',
                      }
                    }),
                  }} />
                </LinearGradient>
              </View>

              {/* Plan Selection Panel - Slides in from right */}
              {showPlanSelection && <PlanSelectionPanel />}

              {/* Footer Illustration */}

              {/* <PageTurnCorner href={"https://smartsaas.co.uk"} /> */}
            </View>
          )}
        <RegisterModal />

        {/* Modern Terms and Privacy Notice - Glass Morphism Style */}
        <View style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 9999,
          ...Platform.select({
            web: {
              position: 'fixed',
            },
            default: {
              position: 'absolute',
            }
          }),
        }}>
          <View style={{
            backgroundColor: Platform.OS === 'web'
              ? (theme ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.15)')
              : (theme ? 'rgba(59, 130, 246, 0.95)' : 'rgba(59, 130, 246, 0.98)'),
            paddingHorizontal: responsive.spacing.lg,
            paddingVertical: responsive.spacing.md,
            borderTopWidth: Platform.OS === 'web' ? 1 : 2,
            borderTopColor: Platform.OS === 'web'
              ? (theme ? 'rgba(255, 255, 255, 0.3)' : 'rgba(255, 255, 255, 0.1)')
              : '#3B82F6',
            ...Platform.select({
              web: {
                backdropFilter: 'blur(20px)',
                boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)',
              },
              default: {
                shadowColor: '#000',
                shadowOffset: { width: 0, height: -4 },
                shadowOpacity: 0.15,
                shadowRadius: 10,
                elevation: 20,
              }
            }),
          }}>
            <XStack
              alignItems="center"
              justifyContent="center"
              space="$2"
              flexWrap="wrap"
              paddingHorizontal={responsive.spacing.sm}
            >
              <FontAwesome6
                name="shield-halved"
                size={responsive.components.iconSize - 2}
                color="white"
                style={{ marginRight: 6 }}
              />
              <Text style={{
                fontSize: responsive.typography.sm,
                color: Platform.OS === 'web'
                  ? (theme ? '#1F2937' : '#F9FAFB')
                  : 'white',
                fontWeight: '500',
                lineHeight: responsive.typography.sm * 1.4,
                flexShrink: 1,
                textAlign: 'center',
              }}>
                By using SmartSaaS®️ Leaf, you agree to our{' '}
              </Text>
              <Pressable
                onPress={() => WebBrowser.openBrowserAsync('https://smartsaas.co.uk/privacy-policy/')}
                style={({ pressed }) => ({
                  opacity: pressed ? 0.8 : 1,
                  transform: [{ scale: pressed ? 0.98 : 1 }],
                  paddingHorizontal: 4,
                  paddingVertical: 2,
                  borderRadius: 4,
                  backgroundColor: pressed ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
                })}
              >
                <Text style={{
                  fontSize: responsive.typography.sm,
                  color: Platform.OS === 'web'
                    ? (theme ? '#4F46E5' : '#818CF8')
                    : 'white',
                  fontWeight: '700',
                  textDecorationLine: 'underline',
                  textDecorationColor: Platform.OS === 'web'
                    ? (theme ? '#4F46E5' : '#818CF8')
                    : 'white',
                }}>
                  privacy policy
                </Text>
              </Pressable>
              <Text style={{
                fontSize: responsive.typography.sm,
                color: Platform.OS === 'web'
                  ? (theme ? '#1F2937' : '#F9FAFB')
                  : 'white',
                fontWeight: '500',
              }}>
                {' '}and{' '}
              </Text>
              <Pressable
                onPress={() => WebBrowser.openBrowserAsync('https://smartsaas.co.uk/terms-and-conditions/')}
                style={({ pressed }) => ({
                  opacity: pressed ? 0.8 : 1,
                  transform: [{ scale: pressed ? 0.98 : 1 }],
                  paddingHorizontal: 4,
                  paddingVertical: 2,
                  borderRadius: 4,
                  backgroundColor: pressed ? (Platform.OS === 'web' ? 'rgba(79, 70, 229, 0.1)' : 'rgba(255, 255, 255, 0.1)') : 'transparent',
                })}
              >
                <Text style={{
                  fontSize: responsive.typography.sm,
                  color: Platform.OS === 'web'
                    ? (theme ? '#4F46E5' : '#818CF8')
                    : 'white',
                  fontWeight: '700',
                  textDecorationLine: 'underline',
                  textDecorationColor: Platform.OS === 'web'
                    ? (theme ? '#4F46E5' : '#818CF8')
                    : 'white',
                }}>
                  terms & conditions
                </Text>
              </Pressable>
            </XStack>
          </View>
        </View>

        {/* Cookie Policy Popover */}
        {showCookiePolicy && (
          <View
            style={{
              position: 'fixed',
              bottom: breakpoints.isMobile ? 10 : 20,
              left: breakpoints.isMobile ? 10 : 20,
              right: breakpoints.isMobile ? 10 : 20,
              zIndex: 10000,
              ...Platform.select({
                web: {
                  position: 'fixed',
                },
                default: {
                  position: 'absolute',
                }
              }),
            }}
          >
            <View style={{
              backgroundColor: theme ? 'rgba(255, 255, 255, 0.98)' : 'rgba(30, 30, 30, 0.98)',
              borderRadius: breakpoints.isMobile ? 12 : 16,
              padding: breakpoints.isMobile ? responsive.spacing.md : responsive.spacing.lg,
              borderWidth: 1,
              borderColor: theme ? 'rgba(0, 0, 0, 0.1)' : 'rgba(255, 255, 255, 0.1)',
              ...Platform.select({
                web: {
                  backdropFilter: 'blur(20px)',
                  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
                },
                default: {
                  shadowColor: '#000',
                  shadowOffset: { width: 0, height: 8 },
                  shadowOpacity: 0.2,
                  shadowRadius: 16,
                  elevation: 24,
                }
              }),
            }}>
              <XStack
                alignItems="flex-start"
                space="$3"
                flexWrap="wrap"
              >
                <YStack flex={1} space="$2">
                  <XStack alignItems="center" justifyContent="space-between">
                    <XStack alignItems="center" space="$2">
                      <FontAwesome6
                        name="cookie-bite"
                        size={responsive.components.iconSize}
                        color={theme ? '#4F46E5' : '#818CF8'}
                      />
                      <Text style={{
                        fontSize: responsive.typography.base,
                        fontWeight: '600',
                        color: theme ? '#1F2937' : '#F9FAFB',
                      }}>
                        Cookie Notice
                      </Text>
                    </XStack>
                    <TouchableOpacity
                      onPress={handleCookieDecline}
                      style={{
                        padding: 4,
                        borderRadius: 4,
                      }}
                    >
                      <AntDesign
                        name="close"
                        size={16}
                        color={theme ? '#6B7280' : '#9CA3AF'}
                      />
                    </TouchableOpacity>
                  </XStack>
                  <Text style={{
                    fontSize: responsive.typography.sm,
                    color: theme ? '#6B7280' : '#D1D5DB',
                    lineHeight: responsive.typography.sm * 1.4,
                    flexShrink: 1,
                  }}>
                    We use cookies to enhance your experience, analyze site traffic, and personalize content. By continuing to use our site, you consent to our use of cookies.{' '}
                    <Pressable
                      onPress={() => WebBrowser.openBrowserAsync('https://smartsaas.co.uk/cookie-policy/')}
                      style={{ display: 'inline' }}
                    >
                      <Text style={{
                        fontSize: responsive.typography.sm,
                        color: theme ? '#4F46E5' : '#818CF8',
                        fontWeight: '600',
                        textDecorationLine: 'underline',
                      }}>
                        Learn more
                      </Text>
                    </Pressable>
                  </Text>
                </YStack>
                <XStack space="$2" alignItems="center" flexWrap="wrap">
                  <Button
                    size="$2"
                    backgroundColor="transparent"
                    onPress={() => WebBrowser.openBrowserAsync('https://smartsaas.co.uk/cookie-preferences/')}
                    pressStyle={{
                      backgroundColor: theme ? '#F9FAFB' : '#374151',
                    }}
                  >
                    <Text style={{
                      fontSize: responsive.typography.xs,
                      color: theme ? '#6B7280' : '#D1D5DB',
                      fontWeight: '500',
                    }}>
                      Customize
                    </Text>
                  </Button>
                  <Button
                    size="$2"
                    backgroundColor={theme ? '#F3F4F6' : '#374151'}
                    onPress={handleCookieDecline}
                    pressStyle={{
                      backgroundColor: theme ? '#E5E7EB' : '#4B5563',
                    }}
                  >
                    <Text style={{
                      fontSize: responsive.typography.xs,
                      color: theme ? '#6B7280' : '#D1D5DB',
                      fontWeight: '500',
                    }}>
                      Decline
                    </Text>
                  </Button>
                  <Button
                    size="$2"
                    backgroundColor={theme ? '#4F46E5' : '#818CF8'}
                    onPress={handleCookieAccept}
                    pressStyle={{
                      backgroundColor: theme ? '#4338CA' : '#6366F1',
                    }}
                  >
                    <Text style={{
                      fontSize: responsive.typography.xs,
                      color: 'white',
                      fontWeight: '600',
                    }}>
                      Accept All
                    </Text>
                  </Button>
                </XStack>
              </XStack>
            </View>
          </View>
        )}
        {
          productId && notifyUser && (
            <View
              style={{
                position: "absolute",
                top: '20%',
                right: '9%',
                transform: [
                  { translateX: -150 },
                  { translateY: -150 }
                ],
                minWidth: 300,
                minHeight: 200,
                maxWidth: breakpoints.isMobile ? '90%' : 400,
                backgroundColor: theme ? 'rgba(255, 255, 255, 0.98)' : 'rgba(30, 30, 30, 0.98)',
                borderRadius: 20,
                padding: responsive.spacing.xl,
                zIndex: 10000,
                borderWidth: 2,
                borderColor: '#3B82F6',
                ...Platform.select({
                  web: {
                    backdropFilter: 'blur(20px)',
                    boxShadow: '0 20px 40px rgba(59, 130, 246, 0.3)',
                  },
                  default: {
                    shadowColor: '#3B82F6',
                    shadowOffset: { width: 0, height: 20 },
                    shadowOpacity: 0.3,
                    shadowRadius: 20,
                    elevation: 25,
                  }
                }),
              }}
            >
              <LinearGradient
                colors={['#4F46E5', '#3B82F6', '#06B6D4']}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 4,
                  borderTopLeftRadius: 18,
                  borderTopRightRadius: 18,
                }}
              />
              <YStack alignItems="center" space="$4">
                {/* Success Icon */}
                <View style={{
                  backgroundColor: '#10B981',
                  borderRadius: 50,
                  padding: responsive.spacing.md,
                  marginTop: responsive.spacing.sm,
                }}>
                  <FontAwesome6
                    name="check-circle"
                    size={32}
                    color="white"
                  />
                </View>
                {/* Header */}
                <YStack alignItems="center" space="$2">
                  <Text style={{
                    fontSize: responsive.typography.xl,
                    fontWeight: '700',
                    color: theme ? '#1F2937' : '#F9FAFB',
                    textAlign: 'center',
                    lineHeight: responsive.typography.xl * 1.2,
                  }}>
                    🎉 Excellent Choice!
                  </Text>

                  <View style={{
                    backgroundColor: theme ? 'rgba(59, 130, 246, 0.1)' : 'rgba(59, 130, 246, 0.2)',
                    paddingHorizontal: responsive.spacing.md,
                    paddingVertical: responsive.spacing.sm,
                    borderRadius: 12,
                    borderWidth: 1,
                    borderColor: '#3B82F6',
                  }}>
                    <Text style={{
                      fontSize: responsive.typography.base,
                      fontWeight: '600',
                      color: '#3B82F6',
                      textAlign: 'center',
                    }}>
                      {validatedProduct?.name || productId}
                    </Text>
                  </View>
                </YStack>

                {/* Message */}
                <YStack alignItems="center" space="$3">
                  <Text style={{
                    fontSize: responsive.typography.base,
                    color: theme ? '#4B5563' : '#D1D5DB',
                    textAlign: 'center',
                    lineHeight: responsive.typography.base * 1.4,
                    fontWeight: '500',
                  }}>
                    You're just one step away from unlocking premium features!
                  </Text>

                  <View style={{
                    backgroundColor: theme ? 'rgba(16, 185, 129, 0.1)' : 'rgba(16, 185, 129, 0.2)',
                    paddingHorizontal: responsive.spacing.lg,
                    paddingVertical: responsive.spacing.md,
                    borderRadius: 12,
                    borderWidth: 1,
                    borderColor: '#10B981',
                  }}>
                    <Text style={{
                      fontSize: responsive.typography.sm,
                      color: '#10B981',
                      textAlign: 'center',
                      fontWeight: '600',
                    }}>
                      💳 Complete registration to secure your purchase
                    </Text>
                  </View>
                </YStack>

                {/* Call to Action */}
                <TouchableOpacity
                  onPress={() => {
                    // Minimize notification to circle indicator and scroll to registration
                    setNotifyUser(false);
                    setShowMinimizedNotification(true);
                    // Optionally scroll to registration form
                  }}
                  style={{
                    backgroundColor: '#3B82F6',
                    paddingHorizontal: responsive.spacing.xl,
                    paddingVertical: responsive.spacing.md,
                    borderRadius: 12,
                    marginTop: responsive.spacing.sm,
                    ...Platform.select({
                      web: {
                        boxShadow: '0 4px 16px rgba(59, 130, 246, 0.3)',
                      },
                      default: {
                        shadowColor: '#3B82F6',
                        shadowOffset: { width: 0, height: 4 },
                        shadowOpacity: 0.3,
                        shadowRadius: 8,
                        elevation: 8,
                      }
                    }),
                  }}
                >
                  <XStack alignItems="center" space="$2">
                    <FontAwesome6
                      name="rocket"
                      size={16}
                      color="white"
                    />
                    <Text style={{
                      fontSize: responsive.typography.base,
                      fontWeight: '600',
                      color: 'white',
                    }}>
                      Log in / Create Account
                    </Text>
                  </XStack>
                </TouchableOpacity>
              </YStack>
            </View>
          )
        }
        {/* Minimized Product Notification - Circle Indicator */}
        {
          showMinimizedNotification && validatedProduct && (
            <View
              style={{
                position: "absolute",
                top: breakpoints.isMobile ? 60 : 80,
                right: breakpoints.isMobile ? 15 : 25,
                width: 60,
                height: 60,
                borderRadius: 30,
                backgroundColor: '#3B82F6',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 9999,
                borderWidth: 3,
                borderColor: 'white',
                ...Platform.select({
                  web: {
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 20px rgba(59, 130, 246, 0.4)',
                  },
                  default: {
                    shadowColor: '#3B82F6',
                    shadowOffset: { width: 0, height: 8 },
                    shadowOpacity: 0.4,
                    shadowRadius: 15,
                    elevation: 15,
                  }
                }),
              }}
            >
              <TouchableOpacity
                onPress={() => {
                  // Expand back to full notification
                  setShowMinimizedNotification(false);
                  setNotifyUser(true);
                }}
                style={{
                  width: '100%',
                  height: '100%',
                  borderRadius: 30,
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <FontAwesome6
                  name="shopping-cart"
                  size={20}
                  color="white"
                />
                <View style={{
                  position: 'absolute',
                  top: -5,
                  right: -5,
                  width: 20,
                  height: 20,
                  borderRadius: 10,
                  backgroundColor: '#10B981',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderWidth: 2,
                  borderColor: 'white',
                }}>
                  <Text style={{
                    fontSize: 10,
                    color: 'white',
                    fontWeight: '700',
                  }}>
                    1
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
          )
        }

        {/* Backend Status Indicator - Bottom Left */}
        <BackendStatusIndicator theme={theme} appVersion={appVersion} />
      </View >
    );
  }


export default LoginScreen;
